/** @jsx jsx */
import { css, jsx, useTheme } from '@emotion/react';

import * as React from 'react';

import { Link } from '@coursera/cds-core';

import type { GetUpcomingCourseStatesQuery_DegreeLearnerCourseStatesV1Resource_get_inProgress as InProgressCourseState } from 'bundles/degree-home/components/v2/UpcomingCourses/__generated__/getUpcomingCourseStatesQuery';
import { getCourseLink } from 'bundles/degree-home/utils/Course';

type Props = {
  courseState: InProgressCourseState;
};

export const CurrentCourseItem: React.FunctionComponent<Props> = ({ courseState }) => {
  const theme = useTheme();
  return (
    <div
      css={css`
        margin-top: ${theme.spacing(16)};
      `}
    >
      <Link
        href={getCourseLink(courseState)}
        variant="quiet"
        typographyVariant="bodyPrimary"
        data-e2e={`current-course-item-link ${courseState.name}`}
      >
        {courseState.name}
      </Link>
    </div>
  );
};
export default CurrentCourseItem;
